import { render, staticRenderFns } from "./GIMD.vue?vue&type=template&id=3da597b6"
import script from "./GIMD.vue?vue&type=script&lang=js"
export * from "./GIMD.vue?vue&type=script&lang=js"
import style0 from "./GIMD.vue?vue&type=style&index=0&id=3da597b6&prod&lang=css"
import style1 from "./GIMD.vue?vue&type=style&index=1&id=3da597b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports